import axios from 'axios';

const BASE_URL = '/main/qualTableAction.do';

const getSITA = () => {
  return window.document.getElementById('sita').value;
};

export const getTableData = ({questionId, chunkSize, lastRowIndex, action, sortDir}) => {
  const sita = getSITA(); //TODO: Should be available globally
  const params = {
	action,
	questionId,
	'loginInfo-header': sita,
	chunkSize,
	lastRowIndex,
	sortDir
  };

  //console.log('With params: ', params);

  return axios.get(
	  BASE_URL,
	  {
		params
	  }
  ).then((result) => {
	const newResult = {};
	newResult.data = result.data && result.data.body ? result.data.body : [];
	newResult.header = result.data.header;
	newResult.hasMoreData = result.data.hasMoreData;
	newResult.sortDir = result.data.sortDir;
	return newResult;
  }).catch((error) => {
	return error;
  });
};

export const getTableFilterData = ({questionId, columnId, searchQuery, chunkSize, lastRowIndex}) => {
  const sita = getSITA(); //TODO: Should be available globally
  const action = 'getFilter';
  const params = {
	'action': action,
	columnId,
	questionId,
	searchQuery,
	'chunkSize': 10,
	'lastRowIndex': lastRowIndex,
	'loginInfo-header': sita
  };

  return axios.get(
	  BASE_URL,
	  {
		params
	  }
  ).then((result) => {
	return result;
  }).catch((error) => {
	return error;
  });
};

export const applyTableFilter = ({questionId, columnFilters, chunkSize, lastRowIndex}) => {
  const sita = getSITA(); //TODO: Should be available globally
  const action = 'applyFilter';
  const params = {
	'action': action,
	questionId,
	'chunkSize': 10,
	'lastRowIndex': 1,
	filterListJson: JSON.stringify(columnFilters),
	'loginInfo-header': sita
  };

  return axios.get(
	  BASE_URL,
	  {params}
  ).then((result) => {
	return result;
  }).catch((error) => {
	return error;
  });
};

export const loadMoreFilter = ({questionId, columnId, chunkSize, lastFilterItemIndex, columnFilters, isSelectAll, selectAllChanged, searchQuery}) => {
  const sita = getSITA(); //TODO: Should be available globally
  const action = 'loadMoreFilter';
  const params = {
	'action': action,
	columnId,
	questionId,
	chunkSize,
	'selectAll': isSelectAll,
	selectAllChanged,
	searchQuery,
	'lastRowIndex': lastFilterItemIndex,
	'loginInfo-header': sita
  };

  return axios.get(
	  BASE_URL,
	  {params}
  ).then((result) => {
	return result;
  }).catch((error) => {
	return error;
  });
};

export const loadQualMedia = (questionId) => {
  //console.log('Loading media for question: ', questionId);
  const sita = getSITA(); //TODO: Should be available globally
  const action = 'getMediaFiles';

  const _startTS = new Date();

  const params = {
	action,
	questionId,
	'loginInfo-header': sita
  };

  return axios.get(
	  BASE_URL,
	  {
		params
	  }
  ).then((result) => {
	console.log('Media for question "', questionId, '": ', result.data);
	console.log('time: ', (new Date()).getTime() - _startTS.getTime());
	return result;
  }).catch((error) => {
	console.error('Failed to load media');
	return error;
  });
};

export default {
  getTableData, getTableFilterData, applyTableFilter, loadMoreFilter, loadQualMedia
};



// WEBPACK FOOTER //
// ./components/qual/api/index.js